export default __webpack_public_path__ + "comingSoon.6f8f9dad012c1440f97c347142254d66.svg";